"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.securityAuthenticationLoginPostAsyncSlice = void 0;
const xuder_1 = require("@sonar-software/xuder");
const api_1 = require("../../../api/index.js");
const sonar_ts_lib_1 = require("@sonar-software/sonar-ts-lib");
exports.securityAuthenticationLoginPostAsyncSlice = (0, xuder_1.createPostAsyncSlice)({
    httpSagaOptions: {
        allowUnauthorized: true,
        successDataHandlers: [
            (data) => {
                if (data.token) {
                    (0, sonar_ts_lib_1.setJWTToken)(data.token);
                }
            }
        ]
    },
    name: 'SecurityAuthorizationLogin',
    receive: false,
    request: true,
    requestHandler: api_1.postLogin
});
//# sourceMappingURL=post.js.map